(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar"]) return;
  try {
    
  class AnnouncementBar extends HTMLElement {
    constructor() {
      super()
    }

    handleClick(e) {
      e.preventDefault()
      const {closeAnnouncement} = e.target.dataset
      if (closeAnnouncement === 'row') {
        e.target.closest('.announcement-bar__row').remove()
      } else {
        this.remove()
      }
    }

    connectedCallback() {
      if (this.querySelector('.announcement-bar__close')) {
      this.querySelector('.announcement-bar__close').addEventListener('click', this.handleClick.bind(this))
      }
    }
  }

  customElements.define('announcement-bar', AnnouncementBar)

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["flooq-advertorial"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('flooq-advertorial')) {
    class FlooqAdvertorial extends HTMLElement {
      connectedCallback() {
        this.frame = requestAnimationFrame(() => this.start());
      }

      start() {
        this.bar = this.querySelector('.sticky-cta');
        this.product = this.querySelector('[data-product]');

        if (!this.bar || !this.product) return;

        this.closings = [
          ...this.querySelectorAll('[data-closing]')
        ];

        this.update = () => {
          const viewport = window.innerHeight;

          const inView = (element) => {
            const rect = element.getBoundingClientRect();
            return rect.top < viewport && rect.bottom > 0;
          };

          this.bar.hidden =
            window.innerWidth >= 768 ||
            this.dataset.editor === 'true' ||
            this.product.getBoundingClientRect().bottom >= 0 ||
            this.getBoundingClientRect().bottom <= 0 ||
            this.closings.some(inView);
        };

        this.queue = () => {
          if (this.pending) return;

          this.pending = requestAnimationFrame(() => {
            this.pending = 0;
            this.update();
          });
        };

        window.addEventListener('scroll', this.queue, {
          passive: true
        });

        window.addEventListener('resize', this.queue);

        this.observer = new ResizeObserver(this.queue);
        this.observer.observe(this);

        this.update();
      }

      disconnectedCallback() {
        cancelAnimationFrame(this.frame);
        cancelAnimationFrame(this.pending);

        if (this.queue) {
          window.removeEventListener('scroll', this.queue);
          window.removeEventListener('resize', this.queue);
        }

        if (this.observer) {
          this.observer.disconnect();
        }
      }
    }

    customElements.define(
      'flooq-advertorial',
      FlooqAdvertorial
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
class FooterCollapsible extends HTMLElement {
  constructor() {
    super();

    this.details = this.querySelector('details');
    this.summary = this.querySelector('summary');
    this.summaryIsEmpty = this.summary.textContent.trim().length == 0;
		this.openDefault = this.dataset.openDefault === 'true'

    this.details.addEventListener('keyup', (event) => event.code.toUpperCase() === 'ESCAPE' && this.close());
    this.summary.addEventListener('click', this.onSummaryClick.bind(this));
    document.addEventListener('matchTablet', this.close.bind(this));
    document.addEventListener('unmatchTablet', this.open.bind(this));

    if (FoxThemeSettings.isTablet) {
			if (!this.openDefault) this.close()
    }

		document.addEventListener('matchTablet', () => {
			if (!this.openDefault) {
				this.close()
			} else {
				this.open()
			}
		})

		document.addEventListener('unmatchTablet', () => {
			this.open()
		})
		
  }

  onSummaryClick(event) {
    event.preventDefault();
    event.target.closest('details').hasAttribute('open')
      ? this.close()
      : this.open();
  }

  open() {
    this.details.setAttribute('open', true);
  }

  close() {
    !this.summaryIsEmpty && this.details.removeAttribute('open');
  }
}

customElements.define('footer-collapsible', FooterCollapsible);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mobile-sticky-bar"]) return;
  try {
    
  class MobileStickyBar extends HTMLElement {
    constructor() {
      super()
      document.body.classList.add('mobile-sticky-bar-enabled')
    }
  }
  customElements.define('mobile-sticky-bar', MobileStickyBar)


  } catch(e) { console.error(e); }
})();
})();
